import React, { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom';

interface Props {
  children?: React.ReactNode;
}

const FullScreenWrapper = ({ children }: Props) => {
  // Read ?isFullScreen=true/false from the URL
  const [searchParams] = useSearchParams();
  const isFullScreen = searchParams.get("isFullScreen") === "true";

  const fullscreenRef = useRef<HTMLDivElement>(null);

  const enterFullScreen = () => {
    if (!fullscreenRef.current) return;
    // If we’re already in fullscreen, don’t request again
    if (
      document.fullscreenElement ||
      (document as any).webkitFullscreenElement ||
      (document as any).msFullscreenElement
    ) {
      return;
    }

    const el = fullscreenRef.current;
    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if ((el as any).webkitRequestFullscreen) {
      (el as any).webkitRequestFullscreen();
    } else if ((el as any).msRequestFullscreen) {
      (el as any).msRequestFullscreen();
    }
  };

  const exitFullScreen = () => {
    // Only call exitFullscreen if we actually have a fullscreen element
    if (
      document.fullscreenElement ||
      (document as any).webkitFullscreenElement ||
      (document as any).msFullscreenElement
    ) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if ((document as any).webkitExitFullscreen) {
        (document as any).webkitExitFullscreen();
      } else if ((document as any).msExitFullscreen) {
        (document as any).msExitFullscreen();
      }
    }
  };

  useEffect(() => {
    if (isFullScreen) {
      enterFullScreen();
    } else {
      exitFullScreen();
    }
    // Cleanup: if this component unmounts while still in fullscreen, exit it
    return () => {
      exitFullScreen();
    };
  }, [isFullScreen]);

  return <div className='w-full h-full' ref={fullscreenRef}>{children}</div>;
};

export default FullScreenWrapper;